<template>
  <section
    ref="carousel"
    class="l-carousel"
  >
    <div class="l-carousel__slides">
      <figure
        v-for="slide in slides"
        :key="slide.id"
        class="l-carousel__item l-figure"
      >
        <img
          class="l-carousel__item-image"
          :src="slide.image.normal"
          :srcset="`
            ${slide.image.normal},
            ${slide.image.retina} 2x
          `"
          :alt="slide.alt"
        >
      </figure>
    </div>
  </section>
</template>

<script>
  import { SLIDES } from './constants'

  const SCROLL_PIXELS = 6

  export default {
    data() {
      return {
        slides: SLIDES,
        scrollPos: 0
      }
    },

    created() {
      this.shuffleArray(this.slides)
    },

    mounted() {
      window.addEventListener('scroll', () => {
        this.slideCarousel()
      })
    },

    methods: {
      slideCarousel() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const carousel = this.$refs.carousel

        if (carousel === null)
          return
        else if (scrollTop === 0)
          carousel.scrollLeft = 0
        else if (scrollTop > this.scrollPos)
          carousel.scrollLeft += SCROLL_PIXELS
        else
          carousel.scrollLeft += -SCROLL_PIXELS

        this.scrollPos = scrollTop <= 0 ? 0 : scrollTop
      },

      shuffleArray (array) {
        let counter = array.length, temp, index
        while ( counter > 0 ) {
          index = Math.floor( Math.random() * counter )
          counter--
          temp = array[ counter ]
          array[ counter ] = array[ index ]
          array[ index ] = temp
        }
        return array
      }
    }
  }
</script>

<style lang="scss" scoped>
  .l-carousel {
    display: block;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 88px;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @include breakpoint(md) {
      margin-top: 120px;
    }

    &__slides {
      display: flex;
      justify-content: space-between;
    }

    &__item {
      height: 124px;
      width: 108px;
      flex: 0 0 auto;
      margin: 0 8px 0 0;

      &:last-child {
        margin: 0;
      }

      &-image {
        display: block;
        width: 100%;
      }

      @include breakpoint(md) {
        height: 242px;
        width: 210px;
        margin: 0 16px 0 0;
      }
    }
  }
</style>
